export const ADD_TO_CART="ADD_TO_CART"
export const ADD_PAYMENT_DETAILS="ADD_PAYMENT_DETAILS"
export const UPDATE_CART="UPDATE_CART"
export const PLACE_ORDER_REQUEST="PLACE_ORDER_REQUEST"
export const PLACE_ORDER_SUCCESS="PLACE_ORDER_SUCCESS"
export const PLACE_ORDER_FAILURE="PLACE_ORDER_FAILURE"


export const GET_CART_SERVER_REQUEST="GET_CART_SERVER_REQUEST"
export const GET_CART_SERVER_SUCCESS="GET_CART_SERVER_SUCCESS"
export const GET_CART_SERVER_FAILD="GET_CART_SERVER_FAILD"


